import {EventRegister} from "../services/tools/EventRegister";

import {
    SET_AGENCY,
    FETCH_INFO, USER_MODIFY, LOGGED_OUT
} from './types';
import {getDomainURI} from "../services/tools/uri";
import REST_API from "../services/api/fetch";

export const setAgency = (value) => {
    return {
        type: SET_AGENCY,
        payload: value
    };
};



const domains  = require( './../res/domains/domains');


export function fetchUserDetail(params) {
    return function (dispatch) {

        let prefix = getDomainURI();
        if (window.location.host !== 'test.bimic.ir'){
            prefix = domains["API"]["bimic"];
        }

        if (prefix === 'localhost:3000') {
            prefix = domains["API"]["localhost"];
        } else if (prefix === 'sodoor724.ir') {
            prefix = domains["API"]["sodoor"]
        }else if (window.location.host == 'test.bimic.ir') {
            prefix = "https://panel.sodoor724.ir/newapi/"
        }

        new REST_API().post('user/detail',{
            agency_id : params.agency_id,
            username : params.username,
        })
            .then((response) => {
                if(typeof response !== "undefined"){
                    dispatch({type: FETCH_INFO, payload: response.result.data});
                }
            }).catch((error) => {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('member');
                dispatch({type: LOGGED_OUT})
            }
        })
        }
}

export function userModify(params, auth) {
    return function (dispatch) {

        let prefix = getDomainURI();
        let domain = domains["API"]["bimic"];

        if (prefix === 'localhost:3000') {
            domain = domains["API"]["localhost"];
        } else if (prefix === 'sodoor724.ir') {
            domain = domains["API"]["sodoor"]
        }
        new REST_API().post( 'user/modify', {
            "agency_id": auth.agency_id,
            "username": auth.username,
            "fname": params.fname,
            "lname": params.lname,
            "melli_code": params.melli_code,
            "address": params.address,
            "email": params.email,
            "tel": params.tel,
            "shaba": params.shaba,
            "card_number": params.card_number,
            "fax": params.fax,
            "postal_code": params.postal_code,
            "city": parseInt(params.city),
            "gender": params.gender,
            "father_name": params.father_name,
            "birthday": params.birthday,

        }).then((response) => {
            if (response.status) {
                dispatch({type: USER_MODIFY, payload: true});
            }
        }).catch((error) => {
            EventRegister.emit('notification.open', 'خطا در برقراری ارتباط با سرور');
        });
      }
    }

